(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["video-shop-the-look"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('video-shop-the-look')) {
    customElements.define('video-shop-the-look', class extends HTMLElement {
      connectedCallback() {
        this.abort = new AbortController();
        const options = { signal: this.abort.signal };
        this.panels = Array.from(this.querySelectorAll('[data-look-panel]'));
        this.tabs = Array.from(this.querySelectorAll('[role="tab"]'));
        if (!this.panels.length) return;
        this.motion = window.matchMedia('(prefers-reduced-motion: reduce)');
        this.userPaused = new Set();
        this.visible = false;
        this.active = 0;
        this.setAttribute('data-enhanced', '');
        this.querySelector('[role="tablist"]').hidden = false;
        this.panels.forEach((panel, index) => {
          panel.setAttribute('role', 'tabpanel');
          panel.setAttribute('aria-labelledby', this.tabs[index].id);
          panel.hidden = index !== 0;
          const button = panel.querySelector('[data-look-play]');
          if (button) {
            button.hidden = false;
            button.addEventListener('click', () => {
              const video = this.loadVideo(panel);
              if (!video) return;
              if (video.paused) { this.userPaused.delete(panel); video.play().catch(() => {}); }
              else { this.userPaused.add(panel); video.pause(); }
            }, options);
          }
        });
        this.tabs.forEach((tab, index) => {
          tab.addEventListener('click', () => this.select(index), options);
          tab.addEventListener('keydown', event => {
            let next = index;
            if (event.key === 'ArrowRight') next = (index + 1) % this.tabs.length;
            else if (event.key === 'ArrowLeft') next = (index + this.tabs.length - 1) % this.tabs.length;
            else if (event.key === 'Home') next = 0;
            else if (event.key === 'End') next = this.tabs.length - 1;
            else return;
            event.preventDefault(); this.select(next); this.tabs[next].focus();
          }, options);
        });
        this.intersections = new Map();
        this.observer = new IntersectionObserver(entries => {
          entries.forEach(entry => this.intersections.set(entry.target, entry.isIntersecting));
          this.visible = this.intersections.get(this.panels[this.active].querySelector('.forest-look__media')) === true;
          this.sync();
        }, { threshold: 0.15 });
        this.panels.forEach(panel => this.observer.observe(panel.querySelector('.forest-look__media')));
        document.addEventListener('visibilitychange', () => this.sync(), options);
        this.motion.addEventListener('change', () => this.sync(), options);
        document.addEventListener('shopify:block:select', event => {
          const index = this.panels.findIndex(panel => panel === event.target || panel.contains(event.target));
          if (index >= 0) this.select(index);
        }, options);
      }
      loadVideo(panel) {
        let video = panel.querySelector('video');
        if (!video) {
          const template = panel.querySelector('[data-look-video]');
          if (!template) return null;
          template.before(template.content.cloneNode(true));
          video = panel.querySelector('video');
          video.muted = true;
          video.playsInline = true;
          const button = panel.querySelector('[data-look-play]');
          const update = () => { button.textContent = video.paused ? button.dataset.playLabel : button.dataset.pauseLabel; };
          video.addEventListener('play', update, { signal: this.abort.signal });
          video.addEventListener('pause', update, { signal: this.abort.signal });
        }
        return video;
      }
      select(index) {
        this.active = index;
        this.panels.forEach((panel, i) => { panel.hidden = i !== index; });
        this.tabs.forEach((tab, i) => { tab.setAttribute('aria-selected', String(i === index)); tab.tabIndex = i === index ? 0 : -1; });
        this.sync();
      }
      sync() {
        this.panels.forEach((panel, index) => {
          const shouldPlay = index === this.active && this.visible && !document.hidden && !this.motion.matches && !this.userPaused.has(panel);
          if (shouldPlay) { const video = this.loadVideo(panel); if (video) video.play().catch(() => {}); }
          else { const video = panel.querySelector('video'); if (video) video.pause(); }
        });
      }
      disconnectedCallback() { this.abort?.abort(); this.observer?.disconnect(); this.querySelectorAll('video').forEach(video => video.pause()); }
    });
  }

  } catch(e) { console.error(e); }
})();
})();
